import { format, isValid, parseISO } from "date-fns";

// Helpers of the «1С» block of a deal (OneCBlock) and Подключения → 1С.

/** what goes before the deal number when nothing is set (crm/api/src/workers/onec.ts) */
export const DEFAULT_KEY_PREFIX = "CRM-";
export const MAX_KEY_TEXT = 20;

/**
 * What a manager writes in the order's comment for this deal: «CRM-101».
 * The prefix and suffix are kept exactly as typed: a space counts.
 */
export const keyExample = (
  prefix: string | undefined,
  suffix: string | undefined,
  dealId: number | string,
) => `${prefix?.trim() ? prefix : DEFAULT_KEY_PREFIX}${dealId}${suffix ?? ""}`;

/** the example with each space shown as «␣», so a trailing space is visible */
export const visibleSpaces = (text: string) => text.replace(/ /g, "␣");

/**
 * The message key of what is wrong with the deal key (the same rules as
 * crm-api's keyMatcher), or null: the prefix has 1–20 characters, a letter and
 * no digits (so a bare number never links); the suffix 0–20, no digits.
 */
export const keyProblem = (prefix: string, suffix: string): string | null => {
  // as typed: spaces count (the server keeps them too)
  const p = prefix;
  const x = suffix;
  if (!p.trim()) return "crm.connections.onec.prefix_empty";
  if (p.length > MAX_KEY_TEXT || x.length > MAX_KEY_TEXT) {
    return "crm.connections.onec.key_long";
  }
  if (/\d/.test(p) || !/\p{L}/u.test(p))
    return "crm.connections.onec.prefix_bad";
  if (/\d/.test(x)) return "crm.connections.onec.suffix_bad";
  return null;
};

export const day = (value: string | null) => {
  const d = value ? parseISO(value) : null;
  return d && isValid(d) ? format(d, "dd.MM.yyyy") : "";
};
export const moment = (value: string) => {
  const d = parseISO(value);
  return isValid(d) ? format(d, "dd.MM.yyyy HH:mm") : "";
};
export const paidPercent = (paid: number, amount: number) =>
  amount > 0
    ? Math.min(100, Math.max(0, Math.floor((paid * 100) / amount)))
    : paid > 0
      ? 100
      : 0;
